export enum ECitiesId {
    MSK = 1,
    SPB = 2,
}